import { Outlet, useParams } from 'react-router-dom';

import { useGetBuildingsByIdQuery } from '@client/api';
import { PageDetailContent, useIsUsageType } from '@client/toolkit';

// COMMENTED OUT: "Enheter" and "Rom" boxes hidden — uncomment to restore
// import { ResidentialUnitsCard } from './components/residential-units-card.component';
// import { ResidentialUnitsRoomsCard } from './components/residential-units-rooms/residential-units-rooms-card.component';

import { CommercialItemsCard } from '../../../components/commercial-items-card/commercial-items-card';
import { CommonAreasListCard } from '../../../components/common-areas-list-card/common-areas-list-card.component';
import { PageContentAnimation } from '../../../../../components/layout/page-content-animation';

export function BuildingDashboardRoute() {
  const { buildingId } = useParams<{ buildingId: string }>();

  const { data: building } = useGetBuildingsByIdQuery({ id: buildingId ?? '' }, { skip: !buildingId });

  const { isCommercialOrMixed, isResidential } = useIsUsageType(building?.usageType);

  return (
    <>
      <PageDetailContent align="left">
        <PageContentAnimation>
          <div className="space-y-2">
            {(building?.usageType == null || isCommercialOrMixed) && <CommercialItemsCard />}

            {/* COMMENTED OUT: "Enheter" box hidden — uncomment to restore
            {(building?.usageType == null || isResidentialOrMixed) && <ResidentialUnitsCard />}
            */}

            {isResidential && <CommonAreasListCard />}

            {/* COMMENTED OUT: "Rom" box hidden — uncomment to restore
            {(building?.usageType == null || isResidentialOrMixed) && <ResidentialUnitsRoomsCard />}
            */}
          </div>
        </PageContentAnimation>
      </PageDetailContent>
      <Outlet />
    </>
  );
}
